import initialState from "core/reducers/initialState";
import ObjectUtil from "../ObjectUtil";
import { nDef } from "../TypeUtils";
import IPropertyPath from "./IPropertyPath";
import IPropertyRecord from "./IPropertyRecord";
import IPropertyReference from "./IPropertyReference";
import IPropertyType from "./IPropertyType";
import PropertyTypeRegistry from "./PropertyTypeRegistry";

// TODO use reselect when resolving refrences in the store
export class PropertyProvider {
	private static KEY = "__PROPERTY";
	private static REFERENCE_KEY = "__PROPERTY_REFF";

	private static isRecord(value) {
		return typeof value === "object" && value !== null && value[PropertyProvider.KEY];
	}

	private static isReference(value) {
		return typeof value === "object" && value !== null && value[PropertyProvider.REFERENCE_KEY];
	}

	public static setAsRecord(record: IPropertyRecord<any>): IPropertyRecord<any> {
		record[PropertyProvider.KEY] = true;
		return record;
	}

	public static setAsReference(ref: IPropertyReference): IPropertyReference {
		ref[PropertyProvider.REFERENCE_KEY] = true;
		return ref;
	}

	public static resolveFields<T extends object>(source: T, store: typeof initialState): T {
		const result = {...source};

		// loop through the object and replace any property records with the processed records
		/* result = {...result, ...ObjectUtil.fromEntries(
				Object.entries(result)
					.filter(PropertyProvider.isRecord)
					.map(([key, value]) => PropertyProvider.resolveRecord(value))
			)}; */

		for(const [key, property] of Object.entries(result)) {
			if(!PropertyProvider.isRecord(property)) {
				continue;
			}

			result[key] = PropertyProvider.resolveRecord(property);
		}

		// loop through the object and replace any property references with the processed records

		/* result = {...result, ...ObjectUtil.fromEntries(
			Object.entries(result)
				.filter(PropertyProvider.isReference)
				.map(([key, value]) => PropertyProvider.resolveReference(value, store))
		)};*/

		for(const [key, property] of Object.entries(result)) {
			if(!PropertyProvider.isReference(property)) {
				continue;
			}

			result[key] = PropertyProvider.resolveReference(property, store);
		}

		return result;
	}

	public static resolveRecord<S, R>(record: IPropertyRecord<S>): R {
		const propertyType: IPropertyType<S, R> = PropertyTypeRegistry.get(record.type);

		if(nDef(propertyType)) {
			throw new Error("Invalid property type: " + record.type);
		}

		if(!record.value) {
			return propertyType.getValue(propertyType.getDefaultValue());
		}

		return propertyType.getValue(record.value, record);
	}

	public static resolveReference<S, R>(reference: IPropertyReference, store: typeof initialState): R {

		// find refrence in store
		const propertyRecord: IPropertyRecord<S> = PropertyProvider.getRecord(reference, store);

		if(nDef(propertyRecord)) {
			throw new Error("Cannot resolve reference location: " + reference.scope + ":" + reference.group);
		}

		return this.resolveRecord(propertyRecord);

	}

	public static isValidReference(reference: IPropertyReference) {
		return  typeof reference === "object" &&
				typeof reference.scope === "string" &&
				typeof reference.group === "string" &&
				typeof reference.field === "string";
	}

	public static getRecord<S>(path: IPropertyReference, store: typeof initialState): IPropertyRecord<S> {
		const { scope, group, field } = path;

		if(!PropertyProvider.isValidReference(path)) {
			throw new Error("invalid property reference");
		}

		// find the record in store
		return store.config[scope][group][field];
	}

	public static isValidRecord<S>(record: IPropertyRecord<S>) {
		return  typeof record === "object" &&
				typeof record.type === "string";
	}
}



// WEBPACK FOOTER //
// ./src/core/util/property/PropertyProvider.ts